/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiserviceMelcoModelsThreadColor,
    ApiserviceMelcoModelsThreadColorFromJSON,
    ApiserviceMelcoModelsThreadColorFromJSONTyped,
    ApiserviceMelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsColorListItem
 */
export interface ApiserviceMelcoModelsColorListItem {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    code?: string | null;
    /**
     * 
     * @type {ApiserviceMelcoModelsThreadColor}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    color?: ApiserviceMelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsColorListItem
     */
    product_name?: string | null;
}

export function ApiserviceMelcoModelsColorListItemFromJSON(json: any): ApiserviceMelcoModelsColorListItem {
    return ApiserviceMelcoModelsColorListItemFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : ApiserviceMelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function ApiserviceMelcoModelsColorListItemToJSON(value?: ApiserviceMelcoModelsColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': ApiserviceMelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight': value.weight,
        'supplier_name': value.supplier_name,
        'product_name': value.product_name,
    };
}


